import { axiosInstance, API_PREFIX, type ApiResponse } from '@/shared/api';
import type { LocationItem } from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/location`;

export const getRegions = async (): Promise<ApiResponse<LocationItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<LocationItem[]>>(`${BASE}/regions-item-list`);
  return data;
};

export const getDistricts = async (parentId: number): Promise<ApiResponse<LocationItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<LocationItem[]>>(`${BASE}/item-list`, {
    params: { parent_id: parentId },
  });
  return data;
};
